import { useSelector } from 'react-redux';
import { useApiMutation } from './useApiMutation';

export const useInviteContactsToUser = ({ userHubsUuid }) => {
  const userApi = useSelector((state) => state.apis.userApi);
  return useApiMutation(
    ({ userObj, apiCallback, trans, successCallback, errorCallback, userUuid }) =>
      new Promise((resolve, reject) => {
        userApi.inviteContactsToUser(
          userUuid,
          userObj,
          apiCallback({
            translator: trans,
            successCallback: () => {
              successCallback();
              resolve();
            },
            errorCallback: (err) => {
              errorCallback(err);
              reject(err);
            },
          })
        );
      }),
    {
      invalidateKeys: [['userHubs', userHubsUuid]], // ✅ auto invalidate
      onSuccess: () => {
        //if anything needed on success
      },
      onError: (error) => {
        // if anything needed on error
      },
    }
  );
};
